import React, { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import ConfirmationPopup from "../common/ConfirmationPopup";
import {
  DeleteSample,
  GetTempBatches,
  ReviewResults,
  SubmitResults,
  DeleteSamples,
} from "../../services/BatchService";
import { BatchName, FormatOutDate } from "../../services/dateService";

import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import HtmlPdf from "../pdfgen/HtmlPdf";
import SampleRow from "./SampleRow";
import CommonLoader from "../../vlp/components/common/CommonLoader";
import EditBatchDialog from "./EditBatchDialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { isMobile } from "react-device-detect";

export default function TempBatchManager({ location, batch }) {
  const [samples, setSamples] = useState([]);
  const [groupedSamples, setGroupedSamples] = useState([]);
  const [reviewIds, setReviewIds] = useState([]);
  const [batchArray, setBatchArray] = useState([]);
  const [fileName, setFileName] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [sampleModals, setSampleModals] = useState({});
  const [htmlPdf, setHtmlPdf] = useState(null);
  const [showPdfComponent, setShowPdfComponent] = useState(false);
  const [printCount, setPrintCount] = useState(0);
  const [showLoader, setShowLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecord, setTotalRecord] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [groupId, setGroupId] = useState(0);
  const [loggedInUser, setLoggedInUser] = useState(0);
  const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] =
    useState(false);
  const [isPrintConfirmationOpen, setIsPrintConfirmationOpen] = useState(false);
  const [isDeleteSingleConfirmationOpen, setIsDeleteSingleConfirmationOpen] =
    useState(false);
  const [deleteSampleId, setDeleteSampleId] = useState(0);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [switchChecked, setSwitchChecked] = useState(true);

  useEffect(() => {
    async function GetData() {
      await LoadData();
    }
    GetData();
  }, [currentPage, pageSize, location, batch, switchChecked]);

  const handleSwitchChange = (event) => {
    setSwitchChecked(event.target.checked);
    // sendApiCall(event.target.checked);
  };
  const LoadData = async () => {
    setLoggedInUser(JSON.parse(localStorage.getItem("loggedInUser")));
    setShowLoader(true);
    setSamples([]);
    setSelectedIds([]);
    try {
      let batchData = await GetTempBatches(
        currentPage,
        pageSize,
        location,
        batch,
        switchChecked
      );
      if (batchData) {
        setSamples(batchData.result);
        setTotalRecord(batchData.count);
        setTotalPages(Math.ceil(batchData.count / pageSize));
      }
    } catch (err) {
      NotificationManager.error(
        "Unable to get the data. Error " + err,
        "Error"
      );
    }
    setShowLoader(false);
  };

  const handleDeleteConfirmationClose = () => {
    setIsDeleteConfirmationOpen(false);
  };

  const handleDeleteConfirmationConfirm = async () => {
    try {
      const response = await DeleteSamples(selectedIds);
      await LoadData();
      NotificationManager.success("Batch deleted", "Success!");
      setIsDeleteConfirmationOpen(false);
      setSelectedIds([]);
    } catch (error) {
      NotificationManager.error("Error deleting samples", "Error!");
      setIsDeleteConfirmationOpen(false);
    }
  };

  const handleOpenDialog = (batch) => {
    setSelectedBatch(batch);
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    setSelectedBatch(null);
  };

  const handleSaveBatch = (updatedBatch) => {
    // Update the batch in your state or perform any necessary actions
    // console.log("Batch saved:", updatedBatch);

    async function GetData() {
      await LoadData();
    }
    GetData();
  };
  const handlePrintConfirmationClose = () => {
    setIsPrintConfirmationOpen(false);
    reviewSamples();
  };
  const handlePrintConfirmationConfirm = async () => {
    PrintReportAndReviewBatch();
    setIsPrintConfirmationOpen(false);
  };

  const handleDeleteSingleConfirmationClose = () => {
    setIsDeleteSingleConfirmationOpen(false);
  };
  const handleDeleteSingleConfirmationConfirm = async () => {
    if (deleteSampleId !== 0) {
      try {
        await DeleteSample(deleteSampleId);
        await LoadData();
        NotificationManager.success("Sample deleted", "Success!");
        setIsDeleteSingleConfirmationOpen(false);
        setDeleteSampleId(0);
      } catch (err) {
        NotificationManager.error("Error deleting samples", "Error!");
        setIsDeleteSingleConfirmationOpen(false);
        setDeleteSampleId(0);
      }
    } else {
      return;
    }
  };
  const setNextPage = () => {
    if (currentPage === totalPages) {
      return;
    } else {
      setCurrentPage(currentPage + 1);
    }
  };
  const setPreviousPage = () => {
    if (currentPage - 1 < 1) {
      return;
    } else {
      setCurrentPage(currentPage - 1);
    }
  };

  const goTOPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  /**
   * Get review comment if applicable for a group and send a review request.
   * @param {[int]} reviewedIds Array of sample ids that will be reviewed
   * @param {int} groupId Id of the group
   */
  const reviewSamples = async () => {
    try {
      let groupedSample = Object.values(groupedSamples).filter(
        (groupedSample) => groupedSample.groupId === groupId
      );

      let reviewComment = "";

      if (groupedSample !== null && groupedSample.length > 0) {
        reviewComment = groupedSample[0].reviewComment;
      }

      reviewComment =
        reviewComment !== null && reviewComment.length !== 0
          ? reviewComment
          : null;

      await ReviewResults(reviewIds, reviewComment);
      NotificationManager.success("Reviews submitted");

      await LoadData();
    } catch (err) {
      NotificationManager.error(
        "Unable to submit reviews. Error " + err,
        "Error Submitting"
      );
    }
  };

  /**
   * Updates the review comment for the appropriate group.
   * @param {int} groupId
   * @param {string} reviewComment
   */
  const editReviewComment = async (groupId, reviewComment) => {
    Object.values(groupedSamples).forEach((groupedSample) => {
      if (groupedSample.groupId === groupId) {
        let dataId = groupedSample.data[0].id;
        updateComment(dataId, reviewComment);
        groupedSample.reviewComment = reviewComment;
      }
    });
  };

  const updateComment = (dataId, newComment) => {
    const updatedSamples = samples.map((sample) => {
      if (sample.id === dataId) {
        return { ...sample, reviewComment: newComment };
      }
      return sample;
    });

    setSamples(updatedSamples);
  };

  useEffect(() => {
    let mappings = {};
    samples.forEach((s) => {
      mappings[s.sampleLabId] = false;
    });
    setSampleModals(mappings);
  }, [samples]);

  useEffect(() => {
    let groups = {};
    let groupId = 0;
    samples.forEach((s) => {
      let key = s.inTime + s.outTime + s.type + s.location;
      if (!(key in groups)) {
        s["groupId"] = groupId;
        groups[key] = {
          groupId: groupId++,
          batchId: BatchName(s.inTime),
          outTime: FormatOutDate(s.outTime),
          type: s.type,
          incubator: s.location,
          data: [s],
          reviewComment: s.reviewComment,
        };
      } else {
        groups[key].data.push(s);
        s["groupId"] = groups[key].groupId;
      }
    });
    setGroupedSamples(groups);
    setHtmlPdf(null);
  }, [samples]);

  const importIndividual = async (id) => {
    try {
      await SubmitResults(id);
      NotificationManager.success("Result submitted");

      await LoadData();
    } catch (err) {
      NotificationManager.error(
        "Unable to submit results. Error " + err,
        "Error Submitting"
      );
    }
  };

  const handleDelete = (id) => {
    setDeleteSampleId(id);
    setIsDeleteSingleConfirmationOpen(true);
  };

  const importMultiple = async () => {
    try {
      await SubmitResults(selectedIds);
      NotificationManager.success("Results submitted");

      await LoadData();
    } catch (err) {
      NotificationManager.error(
        "Unable to submit results. Error " + err,
        "Error Submitting"
      );
    }
  };

  const importBatch = async (selectedSamples) => {
    try {
      await SubmitResults(selectedSamples);
      NotificationManager.success("Results submitted");

      await LoadData();
    } catch (err) {
      NotificationManager.error(
        "Unable to submit results. Error " + err,
        "Error Submitting"
      );
    }
  };

  const PrintReportAndReviewBatch = async () => {
    try {
      await handlePrint(batchArray, fileName);

      await reviewSamples();
    } catch (err) {
      NotificationManager.error(
        "Unable to review batches. Error " + err,
        "Error Submitting"
      );
    }
  };

  const handleSelect = (id, isSelected) => {
    if (isSelected) setSelectedIds([...selectedIds, id]);
    else setSelectedIds((values) => values.filter((o) => o !== id));
  };

  const renderBatch = (batch) => {
    if (!batch) return;

    const batchId = batch.batchId;
    const outTime = batch.outTime;
    const incubator = batch.incubator;
    const type = batch.type;
    const batchArray = batch.data;

    let isReviewedBatch = true;
    batchArray.forEach((sample) => {
      if (!sample.reviewed) isReviewedBatch = false;
    });

    const areSamplesSelected = batchArray.some((sample) =>
      selectedIds.includes(sample.id)
    ); // Check if any samples within this batch are selected

    return (
      <tbody id={`section ${batchId}`}>
        <tr>
          <td
            className="has-text-centered is-vcentered"
            style={{ paddingTop: 30 }}
          >
            <button
              className={
                "button" +
                (loggedInUser.groups && loggedInUser.groups.includes("admin")
                  ? " is-small"
                  : "")
              }
              style={
                loggedInUser.groups && loggedInUser.groups.includes("admin")
                  ? { marginRight: "2px" }
                  : {}
              }
              onClick={() => {
                let deselect = true;
                batchArray.forEach((s) => {
                  if (!selectedIds.includes(s.id)) {
                    deselect = false;
                  }
                });
                if (deselect) {
                  let allSelected = [...selectedIds];
                  batchArray.forEach((s) =>
                    allSelected.splice(allSelected.indexOf(s.id), 1)
                  );
                  setSelectedIds([...new Set(allSelected)]);
                } else {
                  let allSelected = [...selectedIds];
                  batchArray.forEach((s) => allSelected.push(s.id));
                  setSelectedIds([...new Set(allSelected)]);
                }
              }}
            >
              Select-
              <span
                style={{
                  color: "#3488CE",
                  fontWeight: "bold",
                  marginRight: "1px",
                  marginLeft: "0px",
                  padding: "0",
                }}
              >
                ({batchArray.length})
              </span>
            </button>

            {(loggedInUser.groups && loggedInUser.groups.includes("admin") && !isMobile) &&(
              <IconButton
                aria-label="edit"
                style={{ color: "orange" }}
                onClick={() => handleOpenDialog(batchArray[0])}
              >
                <EditIcon />
              </IconButton>
            )}
          </td>
          <td
            className="has-text-centered is-vcentered has-text-link has-text-weight-semibold"
            style={{ paddingTop: 30 }}
          >
            {batchArray[0].inUser}
          </td>
          <td
            className="has-text-centered is-vcentered has-text-link has-text-weight-semibold"
            style={{ paddingTop: 30 }}
          >
            {incubator}
          </td>
          <td
            className="has-text-centered is-vcentered has-text-link has-text-weight-semibold"
            style={{ paddingTop: 30 }}
          >{`${type} ${batchId}`}</td>
          <td
            className="has-text-centered is-vcentered has-text-link has-text-weight-semibold"
            style={{ paddingTop: 30 }}
          >
            {outTime}
          </td>
          <td
            className="has-text-centered  is-vcentered has-text-link has-text-weight-semibold"
            style={{ paddingTop: 30 }}
          >
            {batchArray[0].outUser}
          </td>
          <td
            className="has-text-centered is-vcentered"
            colSpan={2}
            style={{ paddingTop: 30 }}
          >
            <input
              type="text"
              value={batchArray[0]?.reviewComment}
              className="input is-centered is-vcentered"
              onChange={(e) => {
                editReviewComment(batchArray[0]?.groupId, e.target.value);
              }}
              // readOnly={isReviewedBatch}
            />
          </td>
          <td
            className="has-text-centered is-vcentered"
            style={{ paddingTop: 30 }}
          >
            <button
              style={
                isReviewedBatch
                  ? { border: "solid green 3px" }
                  : { border: "solid red 3px" }
              }
              className="button has-text-centered"
              onClick={async () => {
                // Check if review is valid
                if (batchArray.length === 0) return;

                let reviewIds = [];
                let groupId = null;

                // Get all ids in the group to submit to the server for reviewing and get the
                // group id for the review comment
                batchArray.forEach((sample) => {
                  if (groupId == null) groupId = sample.groupId;
                  reviewIds.push(sample.id);
                });
                setReviewIds(reviewIds);
                setBatchArray(batchArray);
                setFileName(`${batchId}-${incubator}-${type}`);
                setGroupId(groupId);
                setIsPrintConfirmationOpen(true);
              }}
            >
              Review Batch
            </button>
          </td>
          <td
            className="has-text-centered is-vcentered"
            style={{ paddingTop: 30 }}
          >
            <button
              className="button has-text-centered is-vcentered"
              onClick={() => {
                let selectedSamples = [];
                batchArray.forEach((s) => selectedSamples.push(s.id));
                importBatch(selectedSamples);
              }}
              disabled={batchArray.some((s) => s.reviewed === false)}
            >
              Import Batch
            </button>
          </td>
          <td
            className="has-text-centered is-vcentered"
            style={{ paddingTop: 30 }}
          >
            <button
              className="button has-text-centered is-vcentered is-link"
              // disabled={!isReviewedBatch}
              onClick={() =>
                handlePrint(batchArray, `${batchId}-${incubator}-${type}`)
              }
            >
              Print Batch Report
            </button>
          </td>
        </tr>
        {areSamplesSelected && (
          <button
            style={{ marginLeft: "15px" }}
            className="button has-text-centered is-vcentered is-danger"
            onClick={() => setIsDeleteConfirmationOpen(true)}
          >
            Delete Selected
          </button>
        )}

        {batchArray.map((s) => {
          return (
            <SampleRow
              key={s.batchId + s.sampleLabId}
              Sample={s}
              onChecked={handleSelect}
              isSelected={selectedIds.some((o) => o === s.id)}
              handleImport={(values) => importIndividual(values)}
              handleDelete={(e) => handleDelete(e)}
              LoadData={()=>LoadData()}
            />
          );
        })}
      </tbody>
    );
  };

  /**
   * Iterates through the grouped sample with the provided group id's
   * samples/batches, extracts data and puts said data in an
   * array to display on a generated pdf for printing.
   * @param {int} groupId Id of the group to print to pdf
   * @returns Array with batch and sample data for pdf generation
   */
  const generatePdfGroupData = (groupId) => {
    // Array that will contain header, subheader and row data
    let docData = [];

    const headers = {
      data: [
        "In User",
        "Incubator",
        "Type/Batch/LabID",
        "Out Time",
        "Out User",
        "Coliform+",
        "Ecoli+",
        "Results",
        "Comments", // Not displayed
      ],
    };

    // Pdf will start with default headers first
    docData.push(headers);

    // Get the grouped sample with the appropriate group ID
    let group = Object.values(groupedSamples).filter((groupedSample) => {
      return groupedSample.groupId === groupId;
    });

    // Check if result exists
    if (group.length === 0) {
      return;
    }

    // The array will only have one element since each grouped sample has a unique groupId
    group = group[0];

    // Push all sample data to docData for pdf generation
    const groupArray = group.data;

    // Used as key in child elements and type/batch ID
    const typeAndBatchId = `${group.type} / ${group.batchId}`;

    // Push batch-level information to docData
    docData.push({
      data: [
        groupArray.length > 0 ? groupArray[0].inUser : "",
        group.incubator,
        typeAndBatchId,
        group.outTime,
        groupArray.length > 0 ? groupArray[0].outUser : "",
        groupArray.length > 0 ? groupArray[0].reviewComment : "",
        "", // No comment since this is a group
      ],
      isSubHeader: true,
      key: typeAndBatchId,
    });

    // Push all sample data to docData
    groupArray.forEach((sample, sampleIndex) => {
      // Indicate if the current sample is the first sample for pdf formatting purposes
      let isFirstSample = false;

      if (sampleIndex === 0) {
        isFirstSample = true;
      }

      // If the sample type contains the substring "TC" and coliform is not null, then coliform
      // is applicable to the row
      const coliformValue =
        sample.coliform !== null && sample.type.includes("TC")
          ? sample.coliform === true
            ? "yes"
            : "no"
          : "";

      // If the sample type contains the substring "TC" and ecoli is not null, then ecoli
      // is applicable to the row
      const ecoliValue =
        sample.ecoli !== null && sample.type.includes("TC")
          ? sample.ecoli === true
            ? "yes"
            : "no"
          : "";

      // If the sample row has a non-null hpc value and its type does not contain the substring "TC"
      // which has coliform and ecoli values, then use the sample row's hpc value if it's not null
      const resultValue =
        (sample.hpc !== null && !sample.type.includes("TC")) ||
        (sample.result !== null && sample.type === "Ecoli")
          ? sample.hpc || sample.result
          : sample.results || "";

      // Sample comment
      const sampleComments = sample.comments ? sample.comments : "";

      docData.push({
        data: [
          "", // In User
          "", // Incubator
          sample.sampleLabId,
          "", // Out Time
          "", // Out User
          coliformValue,
          ecoliValue,
          resultValue,
          sampleComments,
        ],
        isSubHeader: false,
        key: `${typeAndBatchId} - ${sampleIndex}`,
        isFirstSample,
      });
    });

    return docData;
  };

  /**
   * Part of process to generate a pdf for printing which displays the grouped sample with the appropriate groupId.
   * @param {Array} batchArray Array of samples in group
   */
  const handlePrint = async (batchArray = [], fileName = "Print PDF") => {
    if (batchArray.length === 0) return;

    const groupId = batchArray[0].groupId;
    const docData = generatePdfGroupData(groupId);

    setPrintCount(printCount + 1);
    setShowPdfComponent(true);
    setHtmlPdf(
      <HtmlPdf
        data={docData}
        fileName={fileName}
        forcePrint={printCount}
        batchEditHistory={batchArray[0].batchEditHistory}
      />
    );
  };

  return (
    <>
      <CommonLoader loading={showLoader} />
      {!showLoader && (
        <div className="container">
          {showPdfComponent ? (
            <div style={{ display: "none" }}>{htmlPdf}</div>
          ) : null}
          <div className="columns">
            <div className="column">
              <FormControlLabel
                control={
                  <Switch
                    checked={switchChecked}
                    onChange={handleSwitchChange}
                    name="toggleSwitch"
                  />
                }
                label="Show Reviewed"
              />
            </div>
            <div className="column has-text-right">
              <button className="button is-primary" onClick={() => LoadData()}>
                Refresh
              </button>
            </div>
          </div>
          <table className="table is-borderless is-narrow is-hoverable is-fullwidth">
            <thead style={{ borderBottom: "1px solid darkGray" }}>
              <tr>
                <td>
                  Select All{" "}
                  <input
                    type="checkbox"
                    onClick={(e) => {
                      if (e.target.checked) {
                        setSelectedIds(
                          samples.map((s) => {
                            return s.id;
                          })
                        );
                      } else {
                        setSelectedIds([]);
                      }
                    }}
                  />
                </td>
                <td className="has-text-centered px-2">In User</td>
                <td className="has-text-centered px-2">Incubator</td>
                <td className="has-text-centered px-2">Type/Batch/LabID</td>
                <td className="has-text-centered px-2">Out Time</td>
                <td className="has-text-centered px-2">Out User</td>
                <td>
                  <td className="has-text-centered px-5">Coliform+</td>
                  <td className="has-text-centered px-5">Ecoli+</td>
                </td>
                <td className="has-text-centered px-2">Results</td>
                <td className="has-text-centered px-2">Other</td>
                <td></td>
                <td></td>
              </tr>
            </thead>
            {groupedSamples.length === 0 && (
              <tbody>
                <tr>
                  <td>No Batches Found</td>
                </tr>
              </tbody>
            )}
            {Object.keys(groupedSamples).map((key) =>
              renderBatch(groupedSamples[key])
            )}
          </table>
          <button
            className="button"
            style={{ marginBottom: "20px" }}
            disabled={selectedIds.length === 0 ? true : false}
            onClick={() => importMultiple()}
          >
            Import Selected
          </button>
          <br />
          {totalRecord !== 0 && (
            <div className="columns">
              <div className="column">
                <label htmlFor="" className="label">
                  Batches per page
                </label>
                <select
                  className="input"
                  value={pageSize}
                  onChange={(e) => setPageSize(e.target.value)}
                >
                  <option value="2">2</option>
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </select>
              </div>

              <div className="column"></div>
            </div>
          )}
          {totalRecord !== 0 && (
            <div>
              <nav
                className="pagination"
                role="navigation"
                aria-label="pagination"
              >
                <a
                  className={`pagination-previous ${
                    currentPage === 1 ? "is-disabled" : ""
                  }`}
                  title="This is the first page"
                  onClick={setPreviousPage}
                  disabled={currentPage === 1}
                >
                  Previous
                </a>
                <a
                  className={`pagination-next ${
                    totalRecord / currentPage <= 1 ? "is-disabled" : ""
                  }`}
                  onClick={setNextPage}
                  disabled={currentPage === totalPages}
                >
                  Next page
                </a>
                <ul className="pagination-list">
                  <li>
                    <a className="pagination-link is-current">Pages</a>
                  </li>
                  {(() => {
                    const listItems = [];
                    for (let i = 1; i <= totalPages; i++) {
                      listItems.push(
                        <li key={i}>
                          <a
                            className={`pagination-link ${
                              i === currentPage ? "is-current" : ""
                            }`}
                            aria-label={`Goto page ${i}`}
                            aria-current={
                              i === currentPage ? "page" : undefined
                            }
                            onClick={() => goTOPage(i)}
                          >
                            {i}
                          </a>
                        </li>
                      );
                    }
                    return listItems;
                  })()}
                </ul>
              </nav>
            </div>
          )}
        </div>
      )}
      <ConfirmationPopup
        isOpen={isDeleteConfirmationOpen}
        onClose={handleDeleteConfirmationClose}
        onConfirm={handleDeleteConfirmationConfirm}
        title="Delete Confirmation"
        message="Are you sure you would like to delete selected samples?"
        color="red"
      />

      <ConfirmationPopup
        isOpen={isDeleteSingleConfirmationOpen}
        onClose={handleDeleteSingleConfirmationClose}
        onConfirm={handleDeleteSingleConfirmationConfirm}
        title="Delete Confirmation"
        message="Are you sure you would like to delete selected sample?"
        color="red"
      />

      <ConfirmationPopup
        isOpen={isPrintConfirmationOpen}
        onClose={handlePrintConfirmationClose}
        onConfirm={handlePrintConfirmationConfirm}
        title="Print Confirmation"
        message="Do you want to print Batch Report before Review Batch?"
        color="green"
      />
      <EditBatchDialog
        open={isDialogOpen}
        onClose={handleCloseDialog}
        batch={selectedBatch}
        onSave={handleSaveBatch}
      />
    </>
  );
}
